// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import {isDesktop, isNativeMacOS} from '@app/features/ui/utils/NativeUtils';
import {openNativePermissionSettings} from '@app/features/voice/utils/NativePermissions';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const MicrophonePermissionDeniedModal = observer(() => {
	const {t} = useLingui();
	if (isDesktop() && isNativeMacOS()) {
		return (
			<ConfirmModal
				title={t`Microphone Permission Required`}
				description={t`${PRODUCT_NAME} needs access to your microphone. Open System Settings → Privacy & Security → Microphone, allow ${PRODUCT_NAME}, and then restart the app.`}
				primaryText={t`Open Settings`}
				primaryVariant="primary"
				onPrimary={() => openNativePermissionSettings('microphone')}
				secondaryText={t`Close`}
			/>
		);
	}
	const message = isDesktop()
		? t`${PRODUCT_NAME} needs access to your microphone. Allow microphone access in your operating system privacy settings and restart the app.`
		: t`${PRODUCT_NAME} needs access to your microphone to enable voice chat. Please grant microphone permission in your browser settings and try again.`;
	return (
		<ConfirmModal
			title={t`Microphone Permission Required`}
			description={message}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
